<template>
  <div>
    <vxe-grid
      size="small"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:status="{ row }">
        <div class="status-tag">
          <el-tag effect="dark" size="mini" :type="row.dfDefinitionStatus">
            {{ row.dfDefinitionStatusName }}
          </el-tag>
        </div>
      </template>
      <template v-slot:displayCustomer="{ row }">
        <div>{{ row.customerCode == 'ALL' ? 'ALL' : row.custName }}</div>
      </template>
      <template v-slot:displayCreate="{ row }">
        <div>{{ row.createByName }}</div>
        <div>{{ row.createDate }}</div>
      </template>
      <template v-slot:displayModify="{ row }">
        <div>{{ row.modifyByName }}</div>
        <div>{{ row.modifyDate }}</div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import { format } from '@/libs/util.number.js'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { dfDefinitionCode, dfDefinitionNo } = data
      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { code: dfDefinitionCode },
            query: { dfDefinitionNo },
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'enable':
          this.enable(data)
          break
        case 'disableData':
          this.disableData(data)
          break
        case 'copy':
          this.copy(data)
          break
      }
    },
    async del({ dfDefinitionCode }) {
      const confirm = await this.$confirm(
        '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .dfDefinitionDelApi({ dfDefinitionCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async enable({ dfDefinitionCode }) {
      const confirm = await this.$confirm(
        '是否启用标准？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .dfDefinitionEnableApi({ dfDefinitionCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error('启用失败！')
        return
      }
      this.$message({
        message: '启用成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async copy({ dfDefinitionCode }) {
      const confirm = await this.$confirm(
        '是否要复制该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .dfDefinitionCopyApi({ dfDefinitionCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, body, msg } = res
      if (status !== 200) {
        this.$message.error(msg)
        return
      }
      const { dfDefinitionCode: code, dfDefinitionNo } = body || {}
      this.$router.push({
        name: 'inspection-defects-detail',
        params: { code, pageType: 'edit' },
        query: { dfDefinitionNo },
      })
    },
    async disableData({ dfDefinitionCode }) {
      const confirm = await this.$confirm(
        '是否停用标准？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .dfDefinitionDisableApi({ dfDefinitionCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, msg } = res
      if (status !== 200) {
        this.$message.error(msg)
        return
      }
      this.$message({
        message: '停用成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    rollback({ dfDefinitionCode }) {
      this.$prompt('是否要回退吗？', '提示', {
        confirmButtonText:
          this.$l('INDEX.product_dialog_btn_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
        inputPlaceholder:
          this.$l('placeholder_rollback_reason') || '请输入回退原因',
        inputType: 'textarea',
        inputValidator: (value) => {
          if (value) {
            return true
          }
          return this.$l('placeholder_rollback_reason') || '请输入回退原因'
        },
        inputErrorMessage:
          this.$l('placeholder_rollback_reason') || '请输入回退原因',
      })
        .then(({ value }) => {
          if (this.loadingOpen()) return
          this.$api
            .ecomEvgBulkOrderRollbackRequestApi({
              dfDefinitionCode,
              backoutReason: value,
            })
            .then((res) => {
              this.loadingClose()
              const { status } = res
              if (status == 200) {
                this.$message({
                  showClose: true,
                  message:
                    this.$l('tips_rollback_success') || '提交回退申请成功',
                  type: 'success',
                })
              }
              this.$emit('reload')
            })
            .catch(() => {
              this.loadingClose()
            })
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  font-size: 12px;
  .el-tag--N {
    color: #2e9aff;
    background-color: #e7f7ff;
    border: #91d5ff;
  }
  .el-tag--Y {
    color: #70ce46;
    background-color: #f6ffed;
    border: #b7eb8f;
  }
  .el-tag--S {
    color: #fa561f;
    background-color: #fff2e8;
    border: #ffbb96;
  }

  .el-tag--D {
    color: #f74852;
    background-color: #fff1f0;
    border: #ffa39e;
  }
}
</style>
